var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{class:['content-container', { loading: _vm.loading }]},[_vm._t("default")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader-container"},[_c('ui-loader'),_vm._t("loader-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }